import { FC } from 'react';

import { Svg, SvgProps } from '../../components/Svg/Svg.styles';

export const LayoutIcon: FC<React.PropsWithChildren<SvgProps & { isBump?: boolean }>> = ({
  isBump, ...props
}) => {
  return isBump ? (
    <Svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_3420_17333)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 4.77429V8.66667H8.66669V2H11.2258C11.5772 1.99999 11.8804 1.99998 12.13 2.02038C12.3936 2.04191 12.6558 2.08946 12.908 2.21799C13.2844 2.40973 13.5903 2.71569 13.782 3.09202C13.9106 3.34427 13.9581 3.60642 13.9796 3.86998C14 4.11969 14 4.42287 14 4.77429ZM7.33333 2H4.77431C4.42289 1.99999 4.11969 1.99998 3.86998 2.02038C3.60642 2.04191 3.34427 2.08946 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2.08946 3.34427 2.04191 3.60642 2.02038 3.86998C1.99998 4.11969 1.99999 4.42288 2 4.7743V6H7.33333V2ZM2 11.2256V7.33331H7.33333V14H4.77429H4.77425C4.42284 14 4.11968 14 3.86998 13.9796C3.60642 13.958 3.34427 13.9105 3.09202 13.782C2.71569 13.5902 2.40973 13.2843 2.21799 12.908C2.08946 12.6557 2.04191 12.3936 2.02038 12.13C1.99998 11.8803 1.99999 11.5771 2 11.2256ZM8.66669 14H11.2258C11.5772 14 11.8804 14 12.13 13.9796C12.3936 13.9581 12.6558 13.9105 12.908 13.782C13.2844 13.5903 13.5903 13.2843 13.782 12.908C13.9106 12.6557 13.9581 12.3936 13.9796 12.13C14 11.8803 14 11.5771 14 11.2257V10H8.66669V14Z"
          fill="url(#paint0_linear_3420_17333)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3420_17333"
          x="-0.666667"
          y="0"
          width="17.3333"
          height="17.3333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.666667" />
          <feGaussianBlur stdDeviation="0.333333" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3420_17333"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3420_17333"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3420_17333"
          x1="8.00001"
          y1="2"
          x2="8.00001"
          y2="14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop
            offset="1"
            stopColor="white"
            stopOpacity="0.5"
          />
        </linearGradient>
      </defs>
    </Svg>
  ) : (
    <Svg
      width="16"
      height="16"
      viewBox="0 0 18 18"
      data-no-fill
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.09202 16.782L2.54601 15.891H2.54601L2.09202 16.782ZM1.21799 15.908L2.10899 15.454L2.10899 15.454L1.21799 15.908ZM16.782 15.908L15.891 15.454V15.454L16.782 15.908ZM15.908 16.782L15.454 15.891H15.454L15.908 16.782ZM16.782 2.09202L15.891 2.54601V2.54601L16.782 2.09202ZM15.908 1.21799L15.454 2.10899L15.454 2.10899L15.908 1.21799ZM1.21799 2.09202L0.32698 1.63803L0.32698 1.63803L1.21799 2.09202ZM2.09202 1.21799L1.63803 0.32698L1.63803 0.32698L2.09202 1.21799ZM17 10C17.5523 10 18 9.55229 18 9C18 8.44772 17.5523 8 17 8V10ZM8 1C8 0.447715 7.55228 0 7 0C6.44772 0 6 0.447715 6 1H8ZM6 17C6 17.5523 6.44772 18 7 18C7.55228 18 8 17.5523 8 17H6ZM16 4.2V13.8H18V4.2H16ZM13.8 16H4.2V18H13.8V16ZM2 13.8V4.2H0V13.8H2ZM4.2 2H13.8V0H4.2V2ZM4.2 16C3.62345 16 3.25117 15.9992 2.96784 15.9761C2.69617 15.9539 2.59545 15.9162 2.54601 15.891L1.63803 17.673C2.01641 17.8658 2.40963 17.9371 2.80497 17.9694C3.18864 18.0008 3.65645 18 4.2 18V16ZM0 13.8C0 14.3435 -0.000777721 14.8114 0.0305694 15.195C0.0628704 15.5904 0.134186 15.9836 0.326981 16.362L2.10899 15.454C2.0838 15.4045 2.04612 15.3038 2.02393 15.0322C2.00078 14.7488 2 14.3765 2 13.8H0ZM2.54601 15.891C2.35785 15.7951 2.20487 15.6421 2.10899 15.454L0.32698 16.362C0.614601 16.9265 1.07354 17.3854 1.63803 17.673L2.54601 15.891ZM16 13.8C16 14.3765 15.9992 14.7488 15.9761 15.0322C15.9539 15.3038 15.9162 15.4045 15.891 15.454L17.673 16.362C17.8658 15.9836 17.9371 15.5904 17.9694 15.195C18.0008 14.8114 18 14.3435 18 13.8H16ZM13.8 18C14.3436 18 14.8114 18.0008 15.195 17.9694C15.5904 17.9371 15.9836 17.8658 16.362 17.673L15.454 15.891C15.4045 15.9162 15.3038 15.9539 15.0322 15.9761C14.7488 15.9992 14.3766 16 13.8 16V18ZM15.891 15.454C15.7951 15.6421 15.6422 15.7951 15.454 15.891L16.362 17.673C16.9265 17.3854 17.3854 16.9265 17.673 16.362L15.891 15.454ZM18 4.2C18 3.65645 18.0008 3.18864 17.9694 2.80497C17.9371 2.40963 17.8658 2.01641 17.673 1.63803L15.891 2.54601C15.9162 2.59545 15.9539 2.69617 15.9761 2.96784C15.9992 3.25117 16 3.62345 16 4.2H18ZM13.8 2C14.3766 2 14.7488 2.00078 15.0322 2.02393C15.3038 2.04612 15.4045 2.0838 15.454 2.10899L16.362 0.326981C15.9836 0.134186 15.5904 0.0628704 15.195 0.0305694C14.8114 -0.000777721 14.3436 0 13.8 0V2ZM17.673 1.63803C17.3854 1.07354 16.9265 0.614601 16.362 0.32698L15.454 2.10899C15.6422 2.20487 15.7951 2.35785 15.891 2.54601L17.673 1.63803ZM2 4.2C2 3.62345 2.00078 3.25117 2.02393 2.96784C2.04612 2.69617 2.0838 2.59545 2.10899 2.54601L0.32698 1.63803C0.134186 2.01641 0.0628704 2.40963 0.0305695 2.80497C-0.000777721 3.18864 0 3.65645 0 4.2H2ZM4.2 0C3.65645 0 3.18864 -0.000777721 2.80497 0.0305694C2.40963 0.0628704 2.01641 0.134186 1.63803 0.32698L2.54601 2.10899C2.59545 2.0838 2.69617 2.04612 2.96784 2.02393C3.25117 2.00078 3.62345 2 4.2 2V0ZM2.10899 2.54601C2.20487 2.35785 2.35785 2.20487 2.54601 2.10899L1.63803 0.32698C1.07354 0.614601 0.614601 1.07354 0.32698 1.63803L2.10899 2.54601ZM17 8H7V10H17V8ZM8 9V1H6V9H8ZM6 9V17H8V9H6Z"
        fill="currentcolor"
      />
    </Svg>
  );
};
